import connectStats from "instantsearch.js/es/connectors/stats/connectStats.js";
import { useConnector } from "../hooks/useConnector.js";
export function useStats(props, additionalWidgetProperties) {
  return useConnector(connectStats, props, additionalWidgetProperties);
}